var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBoul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    width: 73.4,
    height: 34.7,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.4 34.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e8dccc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.73,32.56c6.53,0,10.54-1.11,13.06-3.59.07-.07.11-.22.13-.41-4.12,1.42-8.57,2.21-13.23,2.21s-9.31-.82-13.5-2.3l.14.13c2.59,2.66,6.86,3.96,13.39,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.92,28.55c-.03.19-.07.34-.13.41-2.52,2.48-6.53,3.59-13.06,3.59s-10.81-1.3-13.39-3.96l-.14-.13c-.83-.29-1.64-.61-2.43-.96-.03.84.03,1.63.52,2.21.17.19.13.15.3.31,3.44,3.56,8.94,4.68,15.1,4.68h.05c6.15,0,11.25-.84,14.69-4.28.7-.7.83-1.69.83-2.75-.76.32-1.53.61-2.32.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.7,28.59c15.75,0,29.84-9.85,34.28-23.95.2-.59.07-1.21-.33-1.7-.4-.5-.99-.77-1.66-.77H4.41c-.66,0-1.26.28-1.66.77-.4.5-.53,1.12-.33,1.7,4.41,14.1,18.53,23.95,34.28,23.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,4.19v.09c.01.32.07.64.17.96,3.12,9.9,10.7,18,20.6,22.27.8.34,1.61.66,2.43.96,4.19,1.48,8.74,2.3,13.5,2.3s9.11-.78,13.23-2.21c.79-.27,1.56-.57,2.32-.88,10.08-4.22,17.83-12.41,20.98-22.44.09-.3.14-.59.17-.89v-.6c-.18-2.05-2.01-3.75-4.38-3.75H4.38C1.85,0-.05,1.97,0,4.19ZM2.75,2.94c.4-.5.99-.77,1.66-.77h64.58c.66,0,1.26.28,1.66.77.4.5.53,1.12.33,1.7-4.44,14.1-18.53,23.95-34.28,23.95S6.83,18.74,2.42,4.65c-.2-.59-.07-1.21.33-1.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBoul);
export default __webpack_public_path__ + "static/media/map-boul.e75457c07e28c7e1a7a8406536f48ff9.svg";
export { ForwardRef as ReactComponent };